import React from 'react'
import { LOCAL_MERCHANT_PATH } from '@hlj/hlj-constant'
import http from '@core/fetch'

/**
 * 主账号登录子账号
 */
export default ({
  storeId,
  children,
  redirectUrl = `${LOCAL_MERCHANT_PATH}#/?superLogin=1&jti=`,
  hasAuth = 1,
  ...rest
}) => {
  const login = async () => {
    const tempwindow = window.open('about:blank')

    const { success, data } = await http.put(
      '/hms/hljMerchantCenter/appApi/authorize/token/update',
      {
        body: {
          storeId
        }
      }
    )

    if (success) {
      tempwindow.location.href = `${redirectUrl}${data.jti}`
    }
  }

  return hasAuth ? (
    <a {...rest} onClick={login}>
      {children}
    </a>
  ) : null
}
